import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ParametrosService } from '../../../../services/parametros.service';
import { Parametros } from '../../../../models/parametros.model';

@Component({
  selector: 'app-parametros',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './parametros.component.html',
  styleUrl: './parametros.component.css',
})
export class ParametrosComponent implements OnInit {
  parametros: Parametros[] = [];
  filteredParametros: Parametros[] = [];
  pagedParametros: Parametros[] = [];

  searchTerm = '';

  currentPage = 0;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage = 0;
  endPage = 0;
  pages: number[] = [];

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private parametrosService: ParametrosService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.handlePostSaveToast();
    this.loadParametros();
  }

  private handlePostSaveToast(): void {
    const successMessage = history.state?.successMessage;
    if (!successMessage) return;
    this.toastr.success(successMessage);
    const currentState = { ...history.state };
    delete currentState.successMessage;
    window.history.replaceState(currentState, '');
  }

  novoParametro(): void {
    this.router.navigate(['/home', 'parametro-parametros-manutencao']);
  }

  editarParametro(id: number): void {
    this.router.navigate(['/home', 'parametro-parametros-manutencao', id]);
  }

  loadParametros(): void {
    this.parametrosService.getParametros().subscribe(data => {
      this.parametros = data;
      this.filteredParametros = data;
      this.currentPage = 0;
      this.updatePagination();
      this.cdr.detectChanges();
    });
  }

  search(): void {
    const term = this.searchTerm.toLowerCase().trim();
    if (term) {
      this.filteredParametros = this.parametros.filter(p =>
        p.descricao?.toLowerCase().includes(term) ||
        p.categoria?.toLowerCase().includes(term)
      );
    } else {
      this.filteredParametros = [...this.parametros];
    }
    this.currentPage = 0;
    this.updatePagination();
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.filteredParametros = [...this.parametros];
    this.currentPage = 0;
    this.updatePagination();
  }

  setPage(page: number): void {
    if (page < 0 || page >= this.totalPages) {
      return;
    }
    this.currentPage = page;
    this.updatePagination();
  }

  updatePagination(): void {
    this.totalPages = Math.max(1, Math.ceil(this.filteredParametros.length / this.itemsPerPage));

    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(0, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages - 1, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(0, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from({ length: this.endPage - this.startPage + 1 }, (_, i) => this.startPage + i);

    const start = this.currentPage * this.itemsPerPage;
    this.pagedParametros = this.filteredParametros.slice(start, start + this.itemsPerPage);
  }
}
